import { render, staticRenderFns } from "./PersonService.vue?vue&type=template&id=4eadc957&scoped=true"
import script from "./PersonService.vue?vue&type=script&lang=js"
export * from "./PersonService.vue?vue&type=script&lang=js"
import style0 from "./PersonService.vue?vue&type=style&index=0&id=4eadc957&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eadc957",
  null
  
)

export default component.exports